import { Button, cn } from "@tellescope/ui";
import { i18n } from "@tellescope/i18n";
import type { AppointmentCategory } from "../../../../shared/schema";

const getCategoryLabels = (): Record<AppointmentCategory, string> => ({
  upcoming: i18n.t("Upcoming", { ns: "calendar" }),
  past: i18n.t("Past", { ns: "calendar" }),
  all: i18n.t("All", { ns: "calendar" }),
});

interface CategorySelectorProps {
  categories: AppointmentCategory[];
  selectedCategory: AppointmentCategory;
  onSelectCategory: (category: AppointmentCategory) => void;
}

export const CategorySelector = ({ categories, selectedCategory, onSelectCategory }: CategorySelectorProps) => {
  return (
    <div className="flex gap-1 p-1 bg-muted rounded-lg">
      {categories.map((category) => (
        <Button
          key={category}
          variant="ghost"
          size="sm"
          className={cn(
            "flex-1 h-8 text-xs font-medium",
            selectedCategory === category
              ? "bg-background text-foreground shadow-sm hover:bg-background"
              : "text-muted-foreground hover:bg-transparent hover:text-foreground"
          )}
          onClick={() => onSelectCategory(category)}
        >
          {getCategoryLabels()[category]}
        </Button>
      ))}
    </div>
  );
};
